import { MainColor } from '../../../palette';

export const getCalendarButtonThemeConfig = () => {
  return {
    states: {
      hover: {
        color: 'navy70' as MainColor,
        backgroundColor: 'navy10' as MainColor,
      },
      active: {
        color: 'navy60' as MainColor,
        backgroundColor: 'navy10' as MainColor,
      },
      focusVisible: {
        color: 'navy60' as MainColor,
        backgroundColor: 'navy90' as MainColor,
      },
      focus: {
        color: 'navy80' as MainColor,
        outlineColor: 'navy40' as MainColor,
      },
    },
  };
};
